module.exports = __webpack_public_path__ + "images/antonio_reyes.jpg?v=ddae6572019d5651e401a9aad2d64e34";